import { render } from "./MyPageLogoutModal.vue?vue&type=template&id=aea27f66"
import script from "./MyPageLogoutModal.vue?vue&type=script&lang=js"
export * from "./MyPageLogoutModal.vue?vue&type=script&lang=js"

import "./MyPageLogoutModal.vue?vue&type=style&index=0&id=aea27f66&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__